import React, { Fragment } from 'react'
import classes from './Home.module.css';
import logo from '../img/drilllogo.png'
import GoButton from '../components/GoButton'
import { Link } from 'react-router-dom'
import Settings from '../settings/Settings'

function Home(props) {
    return (
        <Fragment>
            {props.showSettings && <Settings onClose={props.onClose} sound={props.sound} soundOnOff={props.soundOnOff}/>}
            <div className={classes.home}>
                <h6 style={{ color: "white" }}>MADE PROUDLY WITH REACT</h6>
                <img className={classes.imglogo} src={logo} alt="drilleng" />
                <GoButton />
                <div className={classes.linkblock}>
                    <h2 onClick={props.onClose} style={{cursor: 'pointer'}}>SETTINGS</h2>
                    <Link className={classes.link} to="/manual"><h2>MANUAL</h2></Link>
                    <Link className={classes.link} to="/about"><h2>ABOUT</h2></Link>
                </div>
                <h5 className={classes.max}>2021 (c) Max Koshovyi</h5>
            </div>
        </Fragment>
    );
}

export default Home;
